module.exports = __webpack_public_path__ + "img/miral-roast-package.71dd2a14.jpg";